import * as React from "react";
const SvgFiBrandsSoundcloud = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="m10.069 16.995-.138-2.565.138-6.345a.41.41 0 0 1 .414-.405.41.41 0 0 1 .414.405l.138 6.345-.138 2.565a.41.41 0 0 1-.414.405.41.41 0 0 1-.414-.405m-1.655 0-.138-2.565.138-4.725a.41.41 0 0 1 .414-.405.41.41 0 0 1 .414.405l.138 4.725-.138 2.565a.41.41 0 0 1-.414.405.41.41 0 0 1-.414-.405m-1.655 0-.138-2.565.138-5.265a.41.41 0 0 1 .414-.405.41.41 0 0 1 .414.405l.138 5.265-.138 2.565a.41.41 0 0 1-.414.405.41.41 0 0 1-.414-.405m-1.656 0-.137-2.565.138-4.185a.41.41 0 0 1 .414-.405.41.41 0 0 1 .414.405l.138 4.185-.138 2.565a.41.41 0 0 1-.414.405.41.41 0 0 1-.415-.405m-1.655 0L3.31 14.43l.138-2.025A.41.41 0 0 1 3.862 12a.41.41 0 0 1 .414.405l.138 2.025-.138 2.565a.41.41 0 0 1-.414.405.41.41 0 0 1-.414-.405m-1.655 0-.138-2.565.138-2.565a.41.41 0 0 1 .414-.405.41.41 0 0 1 .414.405l.138 2.565-.138 2.565a.41.41 0 0 1-.414.405.41.41 0 0 1-.414-.405m-1.655-1.08L0 14.43l.138-1.485a.41.41 0 0 1 .414-.405.41.41 0 0 1 .414.405l.138 1.485-.138 1.485a.41.41 0 0 1-.414.405.41.41 0 0 1-.414-.405m19.377-4.784a3.4 3.4 0 0 1 1.175-.21c1.828 0 3.31 1.45 3.31 3.24 0 1.788-1.482 3.24-3.31 3.24h-8.275a.82.82 0 0 1-.828-.812V7.95c0-1.35 2.483-1.35 2.483-1.35 2.744 0 5.02 1.962 5.445 4.531"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFiBrandsSoundcloud;
